import { useMutation, useQuery } from '@tanstack/react-query';
import {
  commonAxiosError,
  queryClient,
} from '../../../../../Utils/TanstackQuery/queryClient';
import { registerStaffApi } from './constantRegistered';
import Toaster from '../../../../../Components/Toaster/Toaster';
import { httpService } from '../../../../../Helpers/Fetcher/axios';

const Toast = Toaster();
export type IRegisteredStaff = {
  id: number;
  email: string;
  phone: string;
  photo: string;
  created_at: string;
  updated_at: string;
  name: string;
  designation: string;
  id_no: string;
  is_contact_person: 0 | 1;
  is_primary: 0 | 1;
};

export const useCreateRegisteredStaffPost = () => {
  return useMutation({
    mutationFn: (data: FormData) =>
      httpService.post({ url: registerStaffApi.ADD_REGISTER_STAFF, data }),
    onSuccess: () => {
      Toast.fire({
        icon: 'success',
        title: `Successfully created!`,
      });
      queryClient.invalidateQueries({
        queryKey: [registerStaffApi.GET_REGISTER_STAFF],
      });
    },
    onError: commonAxiosError(),
  });
};
export const useUpdateRegisteredStaffPost = (id: number | string) => {
  return useMutation({
    mutationFn: (data: FormData) =>
      httpService.patch({
        url: registerStaffApi.ADD_REGISTER_STAFF + '/' + id,
        data,
      }),
    onSuccess: () => {
      Toast.fire({
        icon: 'success',
        title: `Successfully created!`,
      });
      queryClient.invalidateQueries({
        queryKey: [registerStaffApi.GET_REGISTER_STAFF],
      });
    },

    onError: commonAxiosError(),
  });
};
export const useDeleteRegisteredStaff = () => {
  return useMutation({
    mutationFn: (id: number) =>
      httpService.delete({
        url: registerStaffApi.ADD_REGISTER_STAFF + '/' + id,
      }),
    onSuccess: () => {
      Toast.fire({
        icon: 'success',
        title: `Successfully done!`,
      });
      queryClient.invalidateQueries({
        queryKey: [registerStaffApi.GET_REGISTER_STAFF],
      });
    },

    onError: commonAxiosError(),
  });
};

export const useGetRegisteredStaff = () => {
  return useQuery({
    queryKey: [registerStaffApi.GET_REGISTER_STAFF],
    queryFn: () =>
      httpService.get<IRegisteredStaff[]>({
        url: registerStaffApi.GET_REGISTER_STAFF,
      }),
    enabled: true,
  });
};
